// Shared email domain utilities
// Extracted from experience-education.schema for reuse across onboarding flows.

export const OPEN_EMAIL_DOMAINS = [
  '126.com','163.com','aol.com','att.net','bluewin.ch','btinternet.com','comcast.net','cox.net','daum.net','disroot.org','fastmail.com','gmail.com','gmx.com','gmx.net','googlemail.com','hotmail.co.uk','hotmail.com','hushmail.com','icloud.com','inbox.com','keemail.me','laposte.net','libero.it','live.com','lycos.com','mac.com','mail.com','mail.ru','mailfence.com','me.com','msn.com','naver.com','orange.fr','outlook.com','posteo.de','proton.me','protonmail.com','qq.com','rediffmail.com','rogers.com','runbox.com','sbcglobal.net','seznam.cz','sina.com','sky.com','spectrum.net','startmail.com','t-online.de','tutanota.com','verizon.net','virginmedia.com','web.de','yahoo.ca','yahoo.co.in','yahoo.co.uk','yahoo.com','yandex.com','yandex.ru','zoho.com'
];

export function isOpenEmailDomain(emailOrDomain: string | null | undefined): boolean {
  if (!emailOrDomain) return false; // treat missing as not-open to avoid false blocks
  const domain = emailOrDomain.includes('@') ? emailOrDomain.split('@')[1]?.toLowerCase() : emailOrDomain.toLowerCase();
  if (!domain) return false;
  return OPEN_EMAIL_DOMAINS.includes(domain);
}

export function isBusinessEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return !isOpenEmailDomain(email);
}
